import { useCallback, useEffect, useState } from "react"
import { getBotPackageList } from "../../services/botPackagesApis"
import { getMusicPanelList } from "../../services/musicPanelApis"
import { createBot } from "../../services/botApis"
import { toast } from "react-toastify"
import { useSocket, useSocketEvent } from "../../contexts/SocketContext"
import useLivePromise from "../../lib/livePromise"
import MyModal from "../MyModal"
import Input from "../Input"
import { useAuth } from "../../lib/useAuth"

const CreateMusicBotModal = ({ isOpen, toggleModal }) => {
    const { run } = useLivePromise()
    const { isConnected, sendMessage } = useSocket()
    const { user } = useAuth()

    const [packages, setPackages] = useState(null)
    const [allPanels, setAllPanels] = useState(null)
    const [panels, setPanels] = useState(null)
    const [selectedPackage, setSelectedPackage] = useState(null)

    // Create stable callback functions for socket events
    const handlePanelList = useCallback((data) => setAllPanels(data), [])
    const handleBotPackageList = useCallback((data) => setPackages(data), [])

    // Use the stable callbacks with socket events
    useSocketEvent("panelList", handlePanelList)
    useSocketEvent("botPackageList", handleBotPackageList)

    useEffect(() => {
        if (isOpen && isConnected) {
            sendMessage("getBotPackageList")
            if (user?.scope == "admin") {
                sendMessage("getPanelList")
            }
        }
    }, [isOpen, isConnected])

    useEffect(() => {
        if (packages && allPanels && user?.scope == "admin") {
            let data = allPanels.filter((p) => {
                if (p.in_use_count >= p.max_bot) {
                    return false
                }
                if (selectedPackage) {
                    return p.panel_type == selectedPackage.package_bot_type
                } else {
                    return p.panel_type == packages[0].package_bot_type
                }
            })
            setPanels(data)
        }
    }, [packages, selectedPackage, allPanels])

    const createBotFormSubmitHandler = (e) => {
        e.preventDefault()
        const form = new FormData(e.target)
        let data = {
            botName: form.get("bot-name"),
            botServerIp: form.get("bot-server-ip"),
            botDefaultChannelName: form.get("default-channel") == "" ? undefined : form.get("default-channel"),
            botPackageName: form.get("package-name"),
            information: form.get("information") == "" ? undefined : form.get("information"),
            botChannelCommanderIsOn: form.get("channel-commander") == "on" ? true : false,
            panelId: form.get("panel-id"),
        }
        run({
            job: () => createBot(data),
            subscribeEvent: "bot_create_progress",
            doneEvent: "bot_create_done",
            errorEvent: "bot_create_error",
            initialPending: "درحال ارسال درخواست به سرور",
        })
    }

    const handlePackageOnChange = (event) => {
        let packagePriceLabel = document.getElementById("packagePriceLabel")
        const packageName = event.target.value
        const packaage = packages.find((item) => item.package_name === packageName)
        setSelectedPackage(packaage)
        packagePriceLabel.innerHTML = `<div class="show_info text-sm mt-2 text-green-400">${packaage.package_amount.toLocaleString(
            "en-US",
        )} تومان</div>`
    }

    return (
        <MyModal isOpen={isOpen} toggleModal={toggleModal} width="400px" height="500px">
            <div className="">
                <form onSubmit={createBotFormSubmitHandler} className="mt-4 ml-2">
                    <div className="mt-2 grid grid-cols-2 gap-x-5">
                        <Input type="text" dir="rtl" label={"نام بات"} placeholder={"نام بات"} name={"bot-name"} />

                        <Input
                            type="text"
                            dir="ltr"
                            label={"چنل دیفالت"}
                            placeholder={"ایدی/اسم"}
                            name={"default-channel"}
                        />
                    </div>
                    <div className="mt-2">
                        <Input
                            type="text"
                            dir="ltr"
                            label={"ایپی سرور"}
                            placeholder={"ایپی/دامنه"}
                            name={"bot-server-ip"}
                        />
                    </div>

                    <div className="mt-2">
                        <label className="block">پکیج ها</label>
                        <select class="styled-select" name="package-name" onChange={handlePackageOnChange}>
                            {packages &&
                                packages.map((item, index) => (
                                    <option key={index} value={item.package_name}>
                                        {item.package_description}
                                    </option>
                                ))}
                        </select>
                        <span id="packagePriceLabel">
                            <div class="show_info text-sm mt-2 text-green-400">
                                {packages && packages[0]?.package_amount.toLocaleString("en-US")}
                                تومان
                            </div>
                        </span>
                    </div>
                    {panels ? (
                        <div className="mt-2">
                            <label className="block">پنل ها</label>
                            <select class="styled-select" name="panel-id">
                                {panels &&
                                    panels.map((item, index) => (
                                        <option key={index} value={item.id}>
                                            {item.name}
                                        </option>
                                    ))}
                            </select>
                        </div>
                    ) : null}

                    <div className="mt-2">
                        <Input type="text" dir="rtl" label={"توضیحات"} placeholder={"توضیحات"} name={"information"} />
                    </div>
                    <div className="checkbox-holder">
                        <input type="checkbox" name="channel-commander" />
                        <span>چنل کامندر</span>
                    </div>
                    <button type="submit" className="styled-button w-full">
                        ساخت بات
                    </button>
                </form>
            </div>
        </MyModal>
    )
}

export default CreateMusicBotModal
